import { watch } from 'vue';
import type { NavigationGuardNext } from 'vue-router';

import { getInstance, type VueAuth0InstanceType } from '@/plugins/auth';

let loginRouteExists: boolean | null = null;

export function watchAuthLoading(
  next: NavigationGuardNext,
  guardCallback: (instance: VueAuth0InstanceType) => void
) {
  const $auth = getInstance();

  // If loading has already finished, check our auth state using `guard()`
  if (!$auth.loading) {
    return guardCallback($auth);
  }

  // Watch for the loading property to change before we check loggedUser
  const unwatch = watch(() => $auth._state.loading, (loading: boolean) => {
    if (loading === false) {
      unwatch();
      return guardCallback($auth);
    }

    next(false);
  });
}

export function setHasLoginRoute(value: boolean) {
  loginRouteExists = value;
}

export async function isAuthenticated(to, from, next: NavigationGuardNext) {
  watchAuthLoading(next, async $auth => {
    // If the user is authenticated, continue with the route
    if ($auth.loggedUser) {
      return next();
    }

    if (loginRouteExists) {
      // Redirect to the custom login page
      return next({ name: 'login', query: { redirect: to.fullPath } });
    }

    // Fallback for apps without a login page (e.g. ui-admin)
    $auth.loginWithRedirect({ appState: { targetUrl: to.fullPath }, mode: 'login' });
    next(false);
  });
}
